import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import styles from "./index.module.css";
import paymentCards from "../../../utils/img/paymentGateway.webp";
import mobBanking from "../../../utils/img/mobileBanking.avif";
import { useSelector, useDispatch } from "react-redux";
import { initiatePayment } from "../../../store/payment";
import { getFields } from "../../../store/policy";
import { useNavigate } from "react-router-dom";
import { CreditCard, ArrowLeft, ShieldCheck } from "lucide-react";

function Index({ current, setCurrent }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { steps, fields } = useSelector((state) => state.policySlice);
  const { loading } = useSelector((state) => state.paymentSlice);
  const premiumDetails = sessionStorage.getItem("premium");
  const userDetails = sessionStorage.getItem("user");
  const [connectPaymentGateway, setConnectPaymentGateway] = useState(false);

  useEffect(() => {
    if (
      steps &&
      steps.find((s) => s?.step_number === current) &&
      steps.find((s) => s?.step_number === current).form_id &&
      steps.find((s) => s?.step_number === current).id
    ) {
      dispatch(
        getFields({
          formId: steps.find((s) => s?.step_number === current).form_id,
          stepId: steps.find((s) => s?.step_number === current).id,
        })
      );
    }
  }, [steps]);

  useEffect(() => {
    if (connectPaymentGateway) message.success("Connecting to payment gateway...");
  }, [connectPaymentGateway]);

  const submitPolicy = async () => {
    const premiumValues = premiumDetails && JSON.parse(premiumDetails);
    const userInfo = userDetails ? JSON.parse(userDetails) : null;
    const userEmail = userInfo ? JSON.parse(userDetails).email : null;

    navigate("/payment-gateway");
  };

  return (
    <div className={styles.stepWrapper}>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.cardIcon}>
            <CreditCard size={22} />
          </div>
          <div>
            <h3 className={styles.cardTitle}>Payment</h3>
            <span className={styles.cardDesc}>
              Select your preferred payment method to complete your policy
            </span>
          </div>
        </div>

        <div className={styles.cardBody}>
          <div className={styles.paymentLabel}>Pay Via</div>
          <div className={styles.paymentMethods}>
            <div className={styles.paymentOption}>
              <img
                src={paymentCards}
                alt="Card Payment"
                className={styles.paymentImg}
              />
              <span className={styles.paymentOptionLabel}>Card</span>
            </div>
            <div className={styles.paymentOption}>
              <img
                src={mobBanking}
                alt="Mobile Banking"
                className={styles.paymentImg}
              />
              <span className={styles.paymentOptionLabel}>Mobile</span>
            </div>
          </div>

          <div className={styles.secureNotice}>
            <ShieldCheck size={16} color="#028D86" />
            <span>Your payment is secured with 256-bit SSL encryption</span>
          </div>
        </div>
      </div>

      <div className={styles.actions}>
        <Button
          className={styles.backBtn}
          onClick={() => setCurrent((prev) => prev - 1)}
        >
          <ArrowLeft size={16} />
          Back
        </Button>
        <Button
          type="primary"
          className={styles.continueBtn}
          onClick={() => {
            setConnectPaymentGateway(true);
            setTimeout(() => {
              submitPolicy();
              setConnectPaymentGateway(false);
            }, 2000);
          }}
          loading={loading}
        >
          Complete Payment
        </Button>
      </div>
    </div>
  );
}

export default Index;
